<template>
  <the-header></the-header>
  <router-view></router-view>
</template>

<script>
export default{
  computed: {
    didAutoLogout() {
      return this.$store.getters['auth/didAutoLogout'];
    }
  },
  created() {
    this.$store.dispatch('auth/tryLogin');
  },
  watch: {
    didAutoLogout(curValue, oldValue) {
      if (curValue && curValue !== oldValue) {
        this.$router.replace('/auth');
      }
    }
  }
}
</script>

<style>
body {
  margin: 0px auto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
